import React from 'react'
import { withMicrocopy } from '~contexts/MicrocopyContext'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { format } from 'date-fns'

import style from './BlogCards.module.scss'

const BlogCards = ({
  posts,
  microcopy
}) => (
  <div className={style.blogCards}>
    { posts.map((post, index) => (
      <a 
        key={index} 
        className={style.blogCard} 
        href={post.url}
        target='_blank'
        rel="noopener noreferrer"
      >
        <picture>
          <LazyLoadImage src={post.image} alt={post.title} width={311} height={181} />
        </picture>
        <header>{ post.title }</header>
        <span>
          <LazyLoadImage src={post.author.image} alt={post.author.name} width={35} height={35} />
          <span>{ post.author.name }</span>
          <div className={style.date}>
            { format(Date.parse(post.date), 'MMM d') }
          </div> - { microcopy.text('pages.blog.minute_read').replace('%s', post.readTime) }
        </span>
      </a>
    ))}
  </div>
)

export default withMicrocopy(BlogCards)